import { useState } from 'react'
import { Title } from '../../components/Title'
import { Trailers } from './Trailers'

export const HomeStory = () => {
    const ss = [...Array(4).keys()].map((i) => ++i)
    const [showModal, setShowModal] = useState(false)
    const [modalImage, setModalImage] = useState()
    const handleOpenModal = (imagepath) => {
        setModalImage(imagepath)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }
    return (
        <>
            <div className='pt-24 relative'>
                <div className='relative'>
                    <div className='flex'>
                        <img
                            className='w-auto mx-auto'
                            src={`${process.env.PUBLIC_URL}/images/title-wood.png`}
                            alt=' What is Phantom Brave: The Lost Hero?'
                        />
                        <h1 className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-gradient-title text-sm w-full md:text-lg font-pop'>
                            What is Phantom Brave: <br /> The Lost Hero?
                        </h1>{' '}
                    </div>
                </div>
                <div className='font-kiwi text-sub md:text-base text-shadow-white mt-12 w-full md:w-4/5 px-4 md:px-0 mx-auto'>
                    <p>
                        Phantom Brave: The Lost Hero is a colorful <span className='text-pborange'>RPG </span> set in{' '}
                        <span className='text-pborange'>Ivoire</span>, a world dotted with many diverse islands. The
                        story follows the adventures of a young girl named <span className='text-pborange'>Marona</span>
                        , who can communicate with
                        <span className='text-pborange'> Phantoms</span>, the spirits of the dead. In battle, players
                        can utilize the <span className='text-pborange'>“Confine”</span> system to summon their Phantom
                        allies by having them possess items on the map.{' '}
                        <span className='text-pborange'>Units can move around freely on the battlefield</span>, and a
                        high level of over-the-top customization options are available!
                    </p>{' '}
                </div>{' '}
                <div className='my-12 md:my-8 px-4'>
                    <div className='flex flex-wrap relative gap-4 justify-center  mt-20'>
                        {ss.map((data, i) => (
                            <>
                                <div
                                    onClick={() => {
                                        handleOpenModal(data)
                                    }}
                                    className='w-full md:w-[46%] relative'
                                >
                                    <img
                                        className='white-drop-shadow cursor-pointer mx-auto'
                                        src={`${process.env.PUBLIC_URL}/images/ss/ss-top-${data}-s.webp`}
                                        alt={`screen shot of game system ${i}`}
                                    />
                                </div>
                            </>
                        ))}
                    </div>
                    <div
                        onClick={handleCloseModal}
                        className={`z-50 fixed top-0 left-0 w-full h-full bg-black/80 ${
                            showModal ? 'block' : 'hidden'
                        }`}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            className='w-full md:w-[90%] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 m-auto z-30'
                        >
                            <div className='flex flex-row items-center max-w-[1920px] mx-auto md:gap-4'>
                                <div>
                                    {modalImage <= 1 ? (
                                        <img
                                            className='w-full brightness-50 min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                            alt={`arrow previous`}
                                        />
                                    ) : (
                                        <button onClick={() => setModalImage(modalImage - 1)} className=''>
                                            <img
                                                className='w-full min-w-[30px]'
                                                src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                                alt={`arrow previous`}
                                            />{' '}
                                        </button>
                                    )}
                                </div>
                                <div className='relative'>
                                    <button
                                        onClick={handleCloseModal}
                                        className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                                    >
                                        <img
                                            className=''
                                            src={`${process.env.PUBLIC_URL}/images/close.png`}
                                            alt={`close`}
                                        />{' '}
                                    </button>
                                    <img
                                        className='white-drop-shadow '
                                        src={`${process.env.PUBLIC_URL}/images/ss/ss-top-${modalImage}.webp`}
                                        alt={`screen shot of game system`}
                                    />{' '}
                                </div>
                                <div>
                                    {modalImage > 3 ? (
                                        <button>
                                            <img
                                                className='w-full brightness-50 min-w-[30px]'
                                                src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                                alt={`arrow next`}
                                            />
                                        </button>
                                    ) : (
                                        <button onClick={() => setModalImage(modalImage + 1)} className=' '>
                                            <img
                                                className='w-full min-w-[30px]'
                                                src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                                alt={`arrow next`}
                                            />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>{' '}
                </div>
                <div className='font-kiwi text-sub md:text-base text-shadow-white mt-12 w-full md:w-4/5 px-4 md:px-0 mx-auto'>
                    <p>
                        Set on the <span className='text-pborange'>high seas</span>, where ghost ships and pirates run
                        rampant, this story about the <span className='text-pborange'>bond </span>
                        between <span className='text-pborange'>Phantoms</span> and the{' '}
                        <span className='text-pborange'>girl who connects with them</span>...is about to unfold.
                    </p>
                </div>{' '}
            </div>
        </>
    )
}
